import { useMemo, type PropsWithChildren } from "react";

import {
  HotelOffersContext,
  type HotelOffersContextValue,
} from "./HotelOffersContext";

type Props = PropsWithChildren<HotelOffersContextValue>;

export const HotelOffersContextProvider = ({ children, data }: Props) => {
  const contextValue = useMemo(
    () => ({
      data,
    }),
    [data],
  );

  return (
    <HotelOffersContext.Provider value={contextValue}>
      {children}
    </HotelOffersContext.Provider>
  );
};
